import { render, staticRenderFns } from "./NotificationAction.vue?vue&type=template&id=834ec2a8&"
import script from "./NotificationAction.vue?vue&type=script&lang=js&"
export * from "./NotificationAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports